var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.selected==='login')?_c('with-e-mail-login',{on:{"navigate":_vm.navigate}}):_vm._e(),(_vm.selected==='resetPW')?_c('with-e-mail-reset-p-w',{on:{"navigate":_vm.navigate}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }